/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import '../../cash/cardio/api/transactions/ExternalCardTransaction';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "AuthorizePurchaseRequest": {
                "fields": {
                  "cardToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transactionToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "purchaseAmount": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "allowPartial": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "transactionType": {
                    "type": ".squareup.cash.cardio.externalcardtransaction.TransactionType",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "AuthorizePurchaseResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "isAuthorized": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "authorizationAmount": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "wasPartialAuth": {
                    "type": "bool",
                    "id": 4,
                    "rule": "optional"
                  },
                  "remainingAvailableBalance": {
                    "type": ".squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "customerToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "creditLineToken": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.AuthorizePurchaseRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.AuthorizePurchaseResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE AuthorizePurchaseRequest @ squareup/corporate_card/service/authorize_purchase.proto at 11:1
 */
export const AuthorizePurchaseRequest = $root.lookupType('squareup.corporate_card.service.AuthorizePurchaseRequest');
fixType(AuthorizePurchaseRequest, {
  cardToken: {
    notEmpty: true
  },
  transactionToken: {
    notEmpty: true
  },
  purchaseAmount: {
    notEmpty: true
  },
  allowPartial: {
    required: true
  }
});
Builder.createAndAttachToType(AuthorizePurchaseRequest);
/**
 * SOURCE AuthorizePurchaseResponse @ squareup/corporate_card/service/authorize_purchase.proto at 38:1
 */
export const AuthorizePurchaseResponse = $root.lookupType('squareup.corporate_card.service.AuthorizePurchaseResponse');
fixType(AuthorizePurchaseResponse, {
  isAuthorized: {
    required: true
  }
});
Builder.createAndAttachToType(AuthorizePurchaseResponse);